var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDetailHeroBottomWaveMobile = function SvgDetailHeroBottomWaveMobile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 375,
    height: 30,
    fill: "none",
    preserveAspectRatio: "none",
    viewBox: "0 0 375 30"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentcolor",
    d: "M0 .477v29.25h375V.477c-12.157 0-23.364 3.97-37.521 8.984C313.208 18.058 280.266 29.727 219 29.727c-49.051 0-86.084-8.727-120.02-16.723C65.806 5.187 35.59-1.933 0 .477"
  })));
};
export default SvgDetailHeroBottomWaveMobile;